/**
 * Maps the current URL path to a product slug used for FAQ lookup.
 * Order matters — more specific prefixes come first. Falls back to "platform".
 */
const ROUTE_MAP: Array<{ prefix: string; product: string }> = [
  { prefix: "/assistant/configs", product: "agents" },
  { prefix: "/assistant/actions", product: "agents" },
  { prefix: "/assistant/persona-marketplace", product: "persona-marketplace" },
  { prefix: "/assistant", product: "atomassist" },
  { prefix: "/datasets/dataset-marketplace", product: "dataset-marketplace" },
  { prefix: "/datasets", product: "datasets" },
  { prefix: "/document-intelligence", product: "document-intelligence" },
  { prefix: "/products/equipment-ai", product: "equipment-ai" },
  { prefix: "/products/cap-ai", product: "cap-ai" },
  { prefix: "/products/project-genius", product: "project-genius" },
  { prefix: "/products/capitalizer", product: "capitalizer" },
  { prefix: "/products/regulatory-ai", product: "regulatory-ai" },
  { prefix: "/products/safety-analytics", product: "safety-analytics" },
  { prefix: "/fifty-fifty-nine", product: "fifty-fifty-nine-evaluation" },
  { prefix: "/proposal-generation", product: "proposal-generation" },
  { prefix: "/observation-program", product: "observation-program" },
  { prefix: "/vnv-assist", product: "vnv-assist" },
  { prefix: "/parts", product: "parts-ai" },
  { prefix: "/models", product: "models" },
];

export const productForRoute = (pathname: string): string => {
  for (const { prefix, product } of ROUTE_MAP) {
    if (pathname.startsWith(prefix)) return product;
  }
  return "platform";
};
